import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useQueryWithErrorHandling } from 'customHooks/errorHandling';
import { LEGAL_FORMS_QUERY, PAGED_LEGAL_PARTNERS_QUERY } from '../gql/queries/index';
import { useDictionary } from '../gql/hooks/useDictionary';
import BrowserComponentPJ from './BrowserComponentPJ';
import FilterComponentPJ from './FilterComponentPJ';
const defaultLegalPartnerFilters = {
  uniqueId: '',
  name: '',
  legalFormId: null
};

const PJContainer = ({ onTotalCountChange, pager, onTextFieldChange,onRefresh, setOpenModal, partnerTypeId }) => {
  const [filters, setFilters] = useState(defaultLegalPartnerFilters);
  const [specialFilters, setSpecialFilters] = useState({});
  const legalFormsData = useDictionary(LEGAL_FORMS_QUERY);

  const { data } = useQueryWithErrorHandling(PAGED_LEGAL_PARTNERS_QUERY, {
    variables: {
      pager: {
        size: pager.pageSize,
        page: pager.page
      },
      filters: { ...filters, partnerTypeId }
    },
    onCompleted: data => {
      onTotalCountChange(data.pagedLegalPartners.pagination.totalCount);
    }
  });

  const onPropertyChange = (value, columnName) => {
    const updatedFilters = { ...filters, [columnName]: value };
    setSpecialFilters({ ...updatedFilters });
    setFilters(updatedFilters);
    onRefresh();
  };

  const handleSaveData = idx => {
    let selectedItem = data?.pagedLegalPartners?.values?.find((_, index) => idx === index);
    if (!selectedItem) return;
    onTextFieldChange(selectedItem.uniqueId);
    setOpenModal(false);
  };

  return (
    <Grid>
      <Grid container spacing={1}>
        <FilterComponentPJ
          onPropertyChange={onPropertyChange}
          filters={filters}
          specialFilters={specialFilters}
          legalFormsData={legalFormsData?.data}
        />
      </Grid>
      <Grid container my={2}>
        <BrowserComponentPJ handleSaveData={handleSaveData} pjPartners={data?.pagedLegalPartners?.values}></BrowserComponentPJ>
      </Grid>
    </Grid>
  );
};

PJContainer.propTypes = {
  pager: PropTypes.object.isRequired,
  setTotalCount: PropTypes.func,
  onTotalCountChange: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired,
  onTextFieldChange: PropTypes.func.isRequired,
  partnerTypeId: PropTypes.number.isRequired,
  onRefresh: PropTypes.func.isRequired
};

export default PJContainer;
